module.exports = __webpack_public_path__ + "img/logo.565655a5.png";